import { gql } from '@apollo/client';
/**
 * @fragment ContactEmailFragment
 * @since 1.0.0
 */
export const ContactEmailFragment = gql `
  fragment ContactEmailFragment on ContactEmail {
    id
    type
    email
    primary
    createdAt
    updatedAt
  }
`;
